var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.43 49.62",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0089fb;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.75,6.98H4.19c-1.54,0-2.79-1.25-2.79-2.79s1.25-2.79,2.79-2.79h60.55c1.54,0,2.79,1.25,2.79,2.79s-1.25,2.79-2.79,2.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.19,
    cy: 4.19,
    r: 4.19
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.75,27.6H4.19c-1.54,0-2.79-1.25-2.79-2.79s1.25-2.79,2.79-2.79h60.55c1.54,0,2.79,1.25,2.79,2.79s-1.25,2.79-2.79,2.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.06,
    y: 21.13,
    width: 7.36,
    height: 7.36
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.75,48.21H4.19c-1.54,0-2.79-1.25-2.79-2.79s1.25-2.79,2.79-2.79h60.55c1.54,0,2.79,1.25,2.79,2.79s-1.25,2.79-2.79,2.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.19,
    cy: 45.42,
    r: 4.19
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerbutton);
export default __webpack_public_path__ + "static/media/burgerbutton.d32e59f2e7f360e0ebee179d415f87e2.svg";
export { ForwardRef as ReactComponent };